module.exports = __webpack_public_path__ + "static/media/simplePay.aa8c08d9.png";